'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleModal = exports.LocaleModalUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _SwitcherModal = require('components/SwitcherModal/SwitcherModal');

var _decorator = require('helpers/decorator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocaleModalUnwrapped = exports.LocaleModalUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(LocaleModalUnwrapped, _PureComponent);

  function LocaleModalUnwrapped() {
    (0, _classCallCheck3.default)(this, LocaleModalUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (LocaleModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(LocaleModalUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(LocaleModalUnwrapped, [{
    key: 'mapLocales',
    value: function mapLocales() {
      var _props = this.props,
          currentLocale = _props.currentLocale,
          locales = _props.locales;


      return locales.map(function (_ref) {
        var localeKey = _ref.localeKey,
            languageName = _ref.languageName;
        return {
          display: languageName,
          selected: localeKey === currentLocale,
          value: localeKey
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var onSelect = this.props.onSelect;


      return _react2.default.createElement(_SwitcherModal.SwitcherModal, {
        header: _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'locale-modal.select-language',
          defaultMessage: 'Select your language'
        }),
        onClickOption: onSelect,
        options: this.mapLocales()
      });
    }
  }]);
  return LocaleModalUnwrapped;
}(_react.PureComponent);

LocaleModalUnwrapped.propTypes = {
  currentLocale: _propTypes2.default.string,
  locales: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    localeKey: _propTypes2.default.string,
    languageName: _propTypes2.default.string
  })),
  onSelect: _propTypes2.default.func.isRequired
};

var LocaleModal = exports.LocaleModal = (0, _decorator.decorateWith)((0, _Modal2.default)({
  centerVertically: true,
  headerClass: 'modal__locale-modal',
  hideClose: true
}), _reactIntl.injectIntl)(LocaleModalUnwrapped);